module.exports = __webpack_public_path__ + "img/google-app-store.b66832bb.png";